import { useEffect } from "react";
import GrowthStory from "@/components/GrowthStory";
import ClientLogoWall from "@/components/ClientLogoWall";
import Contact from "@/components/Contact";

const GrowthStoryPage = () => {
  useEffect(() => {
    document.title = "Growth Story - ₹0 to ₹3.2 Crore+ Client Results | BrandBorn";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "See real dashboard screenshots and video testimonials from BrandBorn clients. From ₹0 to ₹3.2 Crore+ in total payments on Myntra, ₹43.76 Lakhs on Blinkit, 20.9x RoAS and more.");
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-16" data-testid="growth-story-page">
      <section className="bg-black text-white py-16 px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black mb-4">
            Our <span className="text-red-500">Growth Story</span>
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Real results from real brands — see how BrandBorn helped 1000+ brands achieve massive growth on India's top marketplaces.
          </p>
        </div>
      </section>
      <GrowthStory />
      <ClientLogoWall />
      <Contact />
    </div>
  );
};

export default GrowthStoryPage;
